/**
 * Column IDs for the Orders table
 */
export enum OrdersTableColumnId {
	ORDER_ID = 'orderId',
	BUYER = 'buyer',
	ORDERS_TABLE_TAB = 'ordersTableTab',
	CANCELATION_REASON = 'cancelationReason',
	ORDER_DATE = 'date',
	VEHICLE = 'vehicle',
	PGA = 'partsGarmentsAndAccessories',
	FI = 'financeAndInsurance',
	FI_PROFIT = 'financeAndInsuranceProfitPerRetailUnit',
	TOTAL = 'total',
	PAYMENT_CHOICE = 'paymentChoice',
	PAYMENT = 'payment',
	FINANCING = 'financing',
	REGISTRATION_STATE = 'registrationState',
	DMV_WORKFLOW = 'dmvWorkflow',
	VIN = 'vin',
	FULFILLMENT_TYPE = 'fulfillmentType',
	EST_FULFILLMENT_DATE = 'estFulfillmentDate',
	TASKS = 'numberOfTasks',
	ACTIONS = 'actions',
}
